import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const Modal = (props) => {
    const { className, open, onClose, ...safeProps } = props;
    return (
        <div
            {...safeProps}
            className={`modal ${className} ${open ? '-open' : ''}`}
            aria-hidden={!open}
            onClick={(e) => {
                e.preventDefault();
                onClose();
            }}>
            <div
                className="modal__outer"
                onClick={(e) => {
                    e.stopPropagation();
                }}>
                <button
                    className="modal__close"
                    aria-label="Close"
                    onClick={(e) => {
                        e.preventDefault();
                        onClose();
                    }}>
                    <Icon name="close" />
                </button>

                <div className="modal__inner">{props.children}</div>
            </div>
        </div>
    );
};

Modal.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func,
};

Modal.defaultProps = {
    className: '',
    open: false,
    onClose: () => {},
};

export default Modal;
